<template>
  <div class="col-md-12">
    <br />
    <form
      name="newDocument"
      class="form-horizontal form-label-left"
      @submit.prevent="handleSubmit()"
    >
      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Charge :</label
        >
        <div class="col-md-6 col-sm-6">
          <input
            v-validate="'required|max:255'"
            name="Charge"
            v-model="encodingData.Charge"
            class="form-control"
            :class="{ 'is-invalid': submitted && errors.has('Charge') }" />
            <div v-if="submitted && errors.has('Charge')"
                         class="invalid-feedback">
                        {{ errors.first("Charge") }}
            </div>
        </div>
      </div>
      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Charge Date :</label
        >
        <div class="col-md-6 col-sm-6">
          <input
            type="date"
            name="ChargeDate"
            v-model="encodingData.ChargeDate"
            class="form-control"
          />
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Reference No :</label
        >
        <div class="col-md-6 col-sm-6">
          <input
            v-validate="'max:50'"
            name="ReferenceNo"
            v-model="encodingData.ReferenceNo"
            class="form-control"
            :class="{ 'is-invalid': submitted && errors.has('ReferenceNo') }" />
          <div v-if="submitted && errors.has('ReferenceNo')"
               class="invalid-feedback">
              {{ errors.first("ReferenceNo") }}
          </div>
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Authority :</label
        >
        <div class="col-md-6 col-sm-6">
            <input v-validate="'max:255'"
                   name="Authority"
                   v-model="encodingData.Authority"
                   class="form-control"
                   :class="{ 'is-invalid': submitted && errors.has('Authority') }" />
            <div v-if="submitted && errors.has('Authority')"
                 class="invalid-feedback">
                {{ errors.first("Authority") }}
            </div>
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Country:</label
        >
        <div class="col-md-6 col-sm-6">
          <select
            name="Country"
            v-model="encodingData.Country"
            class="form-control"
          >
            <option value>Select Country</option>
            <option
              v-for="option in countries"
              v-bind:value="option.countryName"
              v-bind:key="option.countryName"
            >
              {{ option.countryName }}
            </option>
          </select>
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >State:</label
        >
        <div class="col-md-6 col-sm-6">
          <select
            name="SourceId"
            v-model="encodingData.State"
            class="form-control"
          >
            <option value>Select State</option>
            <option
              v-for="option in provinces"
              v-bind:value="option.province"
              v-bind:key="option.province"
            >
              {{ option.province }}
            </option>
          </select>
        </div>
      </div>
      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >City :</label
        >
        <div class="col-md-6 col-sm-6">
            <input v-validate="'max:50'"
                   type="text"
                   name="City"
                   v-model="encodingData.City"
                   class="form-control"
                   :class="{ 'is-invalid': submitted && errors.has('City') }" />
            <div v-if="submitted && errors.has('City')"
                 class="invalid-feedback">
                {{ errors.first("City") }}
            </div>
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Comments :</label
        >
        <div class="col-md-6 col-sm-6">
          <textarea
            name="Comments"
            v-model="encodingData.Comments"
            rows="5"
            cols="5"
            class="form-control"
          />
        </div>
      </div>

      <div class="ln_solid"></div>
      <div class="item form-group">
          <div class="col-md-6 col-sm-6">
              <button type="submit" class="btn btn-primary">Save</button>&nbsp;
              <button type="button" v-on:click="clearControls()" class="btn btn-primary">Clear</button>
          </div>
      </div>
    </form>
    <b-modal id="LinkPopLC" title="Link Builder" scrollable hide-footer>
      <LinkPopUp />
    </b-modal>
  </div>
</template>

<script>
import {
  authHeader,
  responseCheck,
  notifyHelper,
  EncodeURL,
  checkLinkMode,
  getlocalstorageCountry,
  getlocalstorageProvince,
  setObject2Link,
} from "../../helper";
import LinkPopUp from "../master/Linking";
import instance from "../../helper/http";
export default {
  data() {
    return {
      encodingData: {
        Charge: "",
        ChargeDate: null,
        ReferenceNo: "",
        Authority: "",
        Country: "",
        State: "",
        City: "",
        Comments: "",
      },
      countries: [],
      provinces: [],
    };
  },
  components: {
    LinkPopUp,
  },
  methods: {
    handleSubmit() {
      let loader = this.$loading.show();
      instance
        .post(EncodeURL + "newlegalcharges", this.encodingData, {
          headers: authHeader(),
        })
        .then((response) => {
          if (response.data.error) {
            loader.hide();
            notifyHelper("error", "There was an error processiv your request!");
          } else {
            loader.hide();
            notifyHelper("success", "Saved");
            //this.clearControls()
            if (checkLinkMode()) {
              if (confirm("Link this newly created entity?")) {
                setObject2Link(response.data.id, "LC");
                this.setLink(response.data.id);
              }
            }
          }
        })
        .catch(function (error) {
          loader.hide();
          responseCheck(error.response.status);
        });
    },
    getlibs() {
      this.countries = getlocalstorageCountry();
      this.provinces = getlocalstorageProvince();
    },
    setLink: function (id) {
      setObject2Link(id, "LC");
      this.$bvModal.show("LinkPopLC");
    },
    clearControls() {
      this.encodingData.Charge = "";
      this.encodingData.ChargeDate = null;
      this.encodingData.ReferenceNo = "";
      this.encodingData.Authority = "";
      this.encodingData.Country = "";
      this.encodingData.State = "";
      this.encodingData.City = "";
      this.encodingData.Comments = "";
    },
  },
  created: function () {
    this.getlibs();
  },
};
</script>

